import { useMutation } from "@tanstack/react-query";

import { deleteIntegration } from "../api/integrations";

export const useDeleteIntegration = () => {
  return useMutation({
    mutationFn: deleteIntegration,
  });
};
